export default __webpack_public_path__ + "static/media/1855.42715f9a.png";